import { useId, useState } from "react";
import { Box, Button, IconButton, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";

export const siteLinks = [
  { label: "Games", href: "/games" },
  { label: "Fortune Games", href: "/fortune" },
  { label: "Competitions", href: "/competitions" },
  { label: "Interactives", href: "/interactives" },
  { label: "Tools", href: "/tools" },
  { label: "Projects", href: "/projects" },
  { label: "About me", href: "/scott-brown" }
];

export function SiteNavigation() {
  const { pathname } = useLocation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const id = useId();
  const active = (href: string) =>
    pathname === href || pathname.startsWith(`${href}/`);
  return (
    <>
      <Box
        component="nav"
        aria-label="Main navigation"
        sx={{ display: { xs: "none", lg: "flex" }, gap: 0.5 }}
      >
        {siteLinks.map(({ label, href }) => (
          <Button
            key={href}
            component={Link}
            to={href}
            aria-current={active(href) ? "page" : undefined}
            sx={{
              color: active(href) ? "primary.main" : "text.secondary",
              bgcolor: active(href) ? "action.selected" : undefined
            }}
          >
            {label}
          </Button>
        ))}
      </Box>
      <IconButton
        id={`${id}-button`}
        aria-label="Open navigation"
        aria-haspopup="menu"
        aria-expanded={Boolean(anchor)}
        aria-controls={anchor ? id : undefined}
        onClick={(event) => setAnchor(event.currentTarget)}
        sx={{ display: { lg: "none" } }}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id={id}
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        slotProps={{ list: { "aria-labelledby": `${id}-button` } }}
      >
        {siteLinks.map(({ label, href }) => (
          <MenuItem
            key={href}
            component={Link}
            to={href}
            selected={active(href)}
            aria-current={active(href) ? "page" : undefined}
            onClick={() => setAnchor(null)}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
